export type Source = {
  citationNumber: number
  snippet: string
  title: string
  url: string
  textMessageSegments: {
    beginOffset: number
    endOffset: number
    snippetExcerpt: { text: string }
  }[]
}

export enum MessageSender {
  USER = 'user',
  BOT = 'bot',
}

export type Message = {
  id: string
  from: MessageSender
  text: string
  attachments?: string[]
  createdAt: number
  sources?: Source[]
  failedAttachments?: string[]
  error?: MessageError
}

export interface MessageError {
  message: string
  code?: string
  canRetry?: boolean
}

export type IncomingMessage = {
  trackingId?: string
  conversationId: string
  parentMessageId: string
  text: string
  sources?: Source[]
  failedAttachments?: string[]
}

export type OutgoingMessage = {
  trackingId?: string
  conversationId?: string
  parentMessageId?: string
  message: string
  attachments?: { s3Uri: string }[]
  chatMode: ChatMode
}

export type PendingMessage = {
  trackingId: string
  text: string
  attachments?: string[]
  error?: MessageError
} | null

export type Conversation = {
  id: string
  title: string
  createdAt: number
  messages: Message[]
  messagesNextToken?: string | null
  isAwaitingResponse?: boolean
  isPinned?: boolean
}

export enum PromptMode {
  JOB_FOLDERS = 'JOB_FOLDERS',
  DOCUMENT_ANALYSIS = 'DOCUMENT_ANALYSIS',
  DATA_ANALYTICS = 'DATA_ANALYTICS',
}

export enum ChatMode {
  RETRIEVAL = 'RETRIEVAL',
  CREATOR = 'CREATOR',
}

/// Server types

export type ServerConversation = {
  conversationId: string
  startTime: string
  title: string
}

export type BaseServerMessage = {
  messageId: string
  body: string
  time: string
  type: 'USER' | 'SYSTEM'
}

type ServerUserMessage = BaseServerMessage & {
  type: 'USER'
  attachments: Array<{
    attachmentId: string
    error?: Record<string, unknown>
    name: string
    status: string
  }>
}

type ServerBotMessage = BaseServerMessage & {
  type: 'SYSTEM'
  sourceAttribution: Array<{
    citationNumber: number
    snippet: string
    textMessageSegments: Array<{
      beginOffset: number
      endOffset: number
      snippetExcerpt: {
        text: string
      }
    }>
    title: string
    url: string
  }>
}

export type ServerMessage = ServerUserMessage | ServerBotMessage
